"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summarizePronunciationProgress = summarizePronunciationProgress;
/** Never mix algorithms, failed attempts, passages, or repeated readings in language progress. */
function summarizePronunciationProgress(attempts, scopeKey, algorithmVersion, language, minimumTexts, windowDays, now) {
    const eligible = attempts
        .filter((attempt) => attempt.status === "completed" &&
        attempt.intelligibility !== null &&
        attempt.algorithmVersion === algorithmVersion &&
        attempt.language === language)
        .sort((left, right) => left.createdAt.localeCompare(right.createdAt) ||
        left.id.localeCompare(right.id));
    const summary = (attempt) => {
        if (!attempt)
            return null;
        const { problemWords: _problemWords, ...result } = attempt;
        return result;
    };
    const text = eligible.filter((attempt) => attempt.scopeKey === scopeKey);
    const counts = new Map();
    for (const attempt of text)
        for (const word of new Set(attempt.problemWords.map((word) => word.normalize("NFC").toLocaleLowerCase(language))))
            counts.set(word, (counts.get(word) ?? 0) + 1);
    const firstByText = new Map();
    for (const attempt of eligible)
        if (attempt.textId && !firstByText.has(attempt.textId))
            firstByText.set(attempt.textId, attempt);
    const cutoff = now.getTime() - windowDays * 86400000;
    const points = [...firstByText.values()].filter((attempt) => Date.parse(attempt.createdAt) >= cutoff &&
        Date.parse(attempt.createdAt) <= now.getTime());
    const ready = points.length >= minimumTexts;
    const acoustics = points.filter((attempt) => attempt.acousticAccuracy !== null);
    return {
        algorithmVersion,
        text: {
            attemptCount: text.length,
            first: summary(text[0]),
            previous: summary(text[text.length - 2]),
            current: summary(text[text.length - 1]),
            best: summary(text.reduce((best, attempt) => !best || attempt.intelligibility > best.intelligibility
                ? attempt
                : best, undefined)),
            recurringWords: [...counts.entries()]
                .filter(([, count]) => count >= 2)
                .sort((left, right) => right[1] - left[1] || left[0].localeCompare(right[0]))
                .slice(0, 5)
                .map(([word, count]) => ({
                word,
                attempts: count,
            })),
        },
        language: {
            windowDays,
            minimumTexts,
            distinctTexts: points.length,
            ready,
            averageIntelligibility: ready
                ? points.reduce((sum, attempt) => sum + attempt.intelligibility, 0) / points.length
                : null,
            averageAcousticAccuracy: ready && acoustics.length >= minimumTexts
                ? acoustics.reduce((sum, attempt) => sum + attempt.acousticAccuracy, 0) / acoustics.length
                : null,
            points: ready
                ? points.map((point) => summary(point))
                : [],
        },
    };
}
//# sourceMappingURL=pronunciationProgress.js.map